$ ->
  if $('.scorecard-management-select2').length > 0
      $('.scorecard-management-select2').select2({
          theme: "bootstrap"
      })